export interface SubscriptionTypeEvent {
  oldSubscriptionTypeId?: number;
  oldSubscriptionTypeName?: string;
  subscriptionId?: number;
  installments?: number;
}
